module.exports = __webpack_public_path__ + "img/nt54-02-80-1.prt.8d3093ac.jpg";